/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_6_PickInputs */

const en_pc_alt_pick_6_pick = /** @type {(inputs: Pc_Alt_Pick_6_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe Acrobat or Foxit PDF Editor, which both sell business plans with support.`)
};

const zh_pc_alt_pick_6_pick = /** @type {(inputs: Pc_Alt_Pick_6_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选 Adobe Acrobat 或 Foxit PDF Editor，两者都提供含技术支持的企业方案。`)
};

/**
* | output |
* | --- |
* | "Adobe Acrobat or Foxit PDF Editor, which both sell business plans with support." |
*
* @param {Pc_Alt_Pick_6_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_6_pick = /** @type {((inputs?: Pc_Alt_Pick_6_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_6_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_6_pick(inputs)
	return zh_pc_alt_pick_6_pick(inputs)
});
export { pc_alt_pick_6_pick as "pc.alt.pick.6.pick" }